<template>
  <div
    v-if="isVisible"
    class="modal-overlay"
    @click.self="closeModal"
  >
    <div class="modal-container">
      <div class="modal-content-custom">
        <button
          type="button"
          class="btn-close-custom"
          @click="closeModal"
          aria-label="Fechar"
        >
          <i class="bi bi-x-lg"></i>
        </button>

        <div class="modal-header-custom">
          <div class="icon-container">
            <i :class="iconClass" class="main-icon"></i>
          </div>
          <h3 class="modal-title-custom">Dispositivo Incompatível</h3>
        </div>

        <div class="modal-body-custom">
          <p class="message-text">{{ message }}</p>
          <div class="divider"></div>
          <p class="help-text">
            Por favor, aceda através de um {{ deviceTypeText }} para uma melhor experiência.
          </p>
        </div>

        <div class="modal-footer-custom">
          <button
            type="button"
            class="btn-understood"
            @click="closeModal"
          >
            <i class="bi bi-check2 me-2"></i>
            Entendido
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeviceIncompatibilityModal",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    appType: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    message() {
      if (this.appType === 1) {
        return "Esta aplicação foi otimizada para computadores e oferece a melhor experiência em ecrãs maiores.";
      }
      if (this.appType === 2) {
        return "Esta aplicação foi desenvolvida especificamente para dispositivos móveis e funcionalidades touch.";
      }
      return "Esta aplicação não está disponível para o seu dispositivo atual.";
    },
    deviceTypeText() {
      if (this.appType === 1) {
        return "computador";
      }
      if (this.appType === 2) {
        return "smartphone ou tablet";
      }
      return "dispositivo compatível";
    },
    iconClass() {
      if (this.appType === 1) {
        return "bi bi-display";
      }
      if (this.appType === 2) {
        return "bi bi-phone";
      }
      return "bi bi-exclamation-triangle";
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-container {
  max-width: 90vw;
  width: 100%;
  max-width: 480px;
}

.modal-content-custom {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
}

.btn-close-custom {
  position: absolute;
  top: 14px;
  right: 14px;
  background: transparent;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: #6c757d;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.modal-header-custom {
  padding: 34px 26px 18px;
  text-align: center;
}

.icon-container {
  margin-bottom: 16px;
}

.main-icon {
  font-size: 3rem;
  color: #0d6efd;
}

.modal-title-custom {
  color: #212529;
  font-weight: 700;
  font-size: 1.35rem;
  margin: 0;
}

.modal-body-custom {
  padding: 0 26px 14px;
  text-align: center;
}

.message-text {
  color: #495057;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 16px;
}

.divider {
  height: 1px;
  background: #e9ecef;
  margin: 16px 0;
}

.help-text {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
}

.modal-footer-custom {
  padding: 18px 26px 26px;
  text-align: center;
}

.btn-understood {
  background: #198754;
  color: #ffffff;
  border: none;
  padding: 10px 26px;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 576px) {
  .modal-container {
    max-width: 95vw;
    margin: 18px;
  }

  .modal-header-custom,
  .modal-body-custom,
  .modal-footer-custom {
    padding-left: 20px;
    padding-right: 20px;
  }

  .main-icon {
    font-size: 2.5rem;
  }
}
</style>
